import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/IndexOptimized";
import { routeHead } from "@/lib/seo/route-head";
import { HERO_PRELOAD } from "@/lib/seo/hero-preload";
import { liveStatsQueryOptions, listingsV2QueryOptions } from "@/lib/queries/publicData";
import { platformStatsQueryOptions } from "@/hooks/usePlatformStats";
import { promotedListingsV2QueryOptions } from "@/hooks/useListingsV2";
import { trustedDealersQueryOptions } from "@/components/home/TrustedDealers";
import { homeRecommendationPoolQueryOptions } from "@/hooks/useHomeRecommendations";
import { homeRotationSlot } from "@/utils/homeRecommendations";
import { buyerCategoryCountsQueryOptions } from '@/hooks/useBuyerCategoryCounts';

export const Route = createFileRoute("/")({
  head: () => {
    const base = routeHead("/");
    return {
      ...base,
      links: [
        ...(base.links ?? []),
        // Homepage-only hreflang set (was previously emitted on every route).
        { rel: "alternate", href: "https://roautomarket.ro", hrefLang: "ro-RO" },
        { rel: "alternate", href: "https://roautomarket.ro", hrefLang: "x-default" },
        ...HERO_PRELOAD,
      ],
    };
  },

  // Real counters + listings in the server-rendered HTML (SEO).
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(buyerCategoryCountsQueryOptions('RO')).catch(() => undefined),
      context.queryClient.ensureQueryData(liveStatsQueryOptions("RO")).catch(() => undefined),
      context.queryClient.ensureQueryData(platformStatsQueryOptions()),
      context.queryClient.ensureQueryData(promotedListingsV2QueryOptions(6, "RO")).catch(() => undefined),
      context.queryClient.ensureQueryData(trustedDealersQueryOptions("RO")).catch(() => undefined),
      // Aceeași cheie ca `RecommendedOffers` (POOL_SIZE=48), altfel SSR-ul
      // descărca 15 MB degeaba iar clientul refăcea oricum fetch-ul.
      context.queryClient
        .ensureQueryData(listingsV2QueryOptions({ country_code: "RO", limit: 48 }))
        .catch(() => undefined),
      context.queryClient.ensureQueryData(homeRecommendationPoolQueryOptions("RO")).catch(() => undefined),
    ]);
    return { homeSlot: homeRotationSlot() };
  },

  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Index />
  );
}
